import React from 'react';
import PropTypes from "prop-types";

import CryptoLinkAddress
  from 'components/dashboard/crypto-links-content/CryptoLinkAddress';
import CryptoShowAsDropdown
  from 'components/dashboard/crypto-links-content/CryptoShowAsDropdown';
import CryptoLinkIsPublished
  from 'components/dashboard/crypto-links-content/CryptoLinkIsPublished';
import CommonLinkDeleteButton
  from 'components/common/link-elements/CommonLinkDeleteButton';

import './CryptoLinktemExpandedContent.css';


function CryptoLinktemExpandedContent(props) {
  const { item, deleteCryptoLink } = props;

  return (
    <div className="crypto-link-item-expanded-content__component">
      <div className="address">
        <CryptoLinkAddress
          key={`crypto-link-address-mobile-key-${item.id}`}
          linkItem={item}
          type="address"
          label={item.crypto_service.form_label}
        />
      </div>

      <div className="show-as">
        <CryptoShowAsDropdown
          key={`crypto-link-show-as-memo-mobile-key-${item.id}`}
          linkItem={item}
          parameter="display_mode"
        />
      </div>

      {item.crypto_service.type === 'address_memo' &&
        <div className="address">
          <CryptoLinkAddress
            key={`crypto-link-memo-mobile-key-${item.id}`}
            linkItem={item}
            type="memo"
            label={item.crypto_service.memo_name}
          />
        </div>
      }

      {item.crypto_service.type === 'address_memo' &&
        <div className="show-as">
          <CryptoShowAsDropdown
            key={`crypto-link-show-as-memo-mobile-key-${item.id}`}
            linkItem={item}
            parameter="display_mode_memo"
          />
        </div>
      }

      <div className="is-published">
        <CryptoLinkIsPublished
          expandedContent
          key={`crypto-link-is-published-mobile-key-${item.id}`}
          linkItem={item}
        />
      </div>

      <div className="delete">
        <CommonLinkDeleteButton
          key={`crypto-link-delete-icon-mobile-key-${item.id}`}
          linkItem={item}
          deleteFunction={deleteCryptoLink}
        />
      </div>
    </div>
  );
}

CryptoLinktemExpandedContent.propTypes = {
  deleteCryptoLink: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

export default CryptoLinktemExpandedContent;
